import { isEqual, isFunction } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useForm, useFormState } from "react-final-form";
import RffForm from "./RffForm";

const RffFormChanges = ({
  children,
  hasChangesContent,
  initialValues,
  // suppressFooter = true,
  suppressFooter,
  onCancelText,
  loading,
  formSpy = false,
  // formSpy = true,
  onCancel,
  onSubmit,
  submitText = "Save Changes",
  submitButtonSpacing = 4,
  footerStartContent,
  disabledWhenNoChanges = true,
  sx,
}) => {
  const [formKey, setFormKey] = useState(0); // Key to force form re-initialization
  const { changes, setChanges, hasChanges, getPayload, resetChanges } =
    useFormChanges();

  const handleOnSubmit = async (values, form) => {
    const changedValues = getPayload();

    if (isFunction(onSubmit)) {
      onSubmit(changedValues, { changedValues, form, values, changes });
      return;
    }
  };

  return (
    <RffForm
      key={formKey} // Force re-initialization when profile loads
      suppressFooter={suppressFooter}
      formSpy={formSpy}
      onCancel={!hasChanges ? null : onCancel}
      onCancelText={onCancelText}
      // suppressFooter={hasChanges ? undefined : () => null}
      initialValues={initialValues}
      // formSpy
      loading={loading}
      sx={sx}
      disabled={!hasChanges && disabledWhenNoChanges}
      submitText={submitText}
      footerStartContent={footerStartContent}
      onSubmit={handleOnSubmit}
      // Show save button only when there are changes
      // renderFooter={hasChanges ? undefined : () => null}
    >
      <FormChangeTracker
        onChangesUpdate={setChanges}
        initialValues={initialValues} // Pass initial values to tracker
      />

      {children}
      {hasChanges ? hasChangesContent : null}
    </RffForm>
  );
};

const FormChangeTracker = ({ onChangesUpdate, initialValues }) => {
  const form = useForm();
  const { values, pristine, dirty } = useFormState();
  const [changedValues, setChangedValues] = useState({});
  const initialValuesRef = useRef(null);
  const [isInitialized, setIsInitialized] = useState(false);

  // Update initial values reference when initialValues prop changes
  useEffect(() => {
    if (initialValues) {
      // Always update the reference when initialValues change
      initialValuesRef.current = JSON.parse(JSON.stringify(initialValues));

      if (!isInitialized) {
        setIsInitialized(true);
      }

      // Reset changes when initial values change (e.g., after save)
      setChangedValues({});
      if (onChangesUpdate) {
        onChangesUpdate({});
      }
    }
  }, [initialValues, onChangesUpdate]); // Remove isInitialized from dependencies

  // Track changes only after initialization
  useEffect(() => {
    if (!isInitialized || !initialValuesRef.current || !values) return;

    const changes = {};
    const compareValues = (current, initial, path = "") => {
      // Handle cases where current has keys that initial doesn't
      const allKeys = new Set([
        ...Object.keys(current || {}),
        ...Object.keys(initial || {}),
      ]);

      allKeys.forEach((key) => {
        const currentPath = path ? `${path}.${key}` : key;
        const currentValue = current?.[key];
        const initialValue = initial?.[key];

        if (currentValue === undefined && initialValue === undefined) {
          return;
        }

        if (
          typeof currentValue === "object" &&
          currentValue !== null &&
          !Array.isArray(currentValue)
        ) {
          compareValues(currentValue, initialValue || {}, currentPath);
        } else if (Array.isArray(currentValue)) {
          if (!isEqual(currentValue, initialValue)) {
            changes[currentPath] = currentValue;
          }
        } else if (currentValue !== initialValue) {
          changes[currentPath] = currentValue;
        }
      });
    };

    compareValues(values, initialValuesRef.current);
    setChangedValues(changes);

    if (onChangesUpdate) {
      onChangesUpdate(changes);
    }
  }, [values, isInitialized, onChangesUpdate]);

  // Reset tracking when form is reset
  useEffect(() => {
    const unsubscribe = form.subscribe(
      ({ pristine }) => {
        if (pristine && isInitialized) {
          setChangedValues({});
          if (onChangesUpdate) {
            onChangesUpdate({});
          }
        }
      },
      { pristine: true },
    );

    return unsubscribe;
  }, [form, isInitialized, onChangesUpdate]);

  return null; // This component doesn't render anything
};

// Hook to use form changes
const useFormChanges = () => {
  const [changes, setChanges] = useState({});
  const hasChanges = Object.keys(changes).length > 0;

  return {
    changes,
    setChanges,
    hasChanges,
    getPayload: () => {
      // Convert dot notation back to nested object for payload
      const payload = {};
      Object.entries(changes).forEach(([path, value]) => {
        const keys = path.split(".");
        let current = payload;
        keys.forEach((key, index) => {
          if (index === keys.length - 1) {
            current[key] = value;
          } else {
            current[key] = current[key] || {};
            current = current[key];
          }
        });
      });
      return payload;
    },
    resetChanges: () => setChanges({}),
  };
};

export default RffFormChanges;

// import { isEqual, isFunction } from "lodash";
// import React, { useEffect, useRef, useState } from "react";
// import RffSubmitButton from "./RffSubmitButton";
// import RffForm from "./RffForm";
// import { useForm, useFormState } from "react-final-form";

// const RffFormChanges = ({
//   children,
//   hasChangesContent,
//   initialValues,
//   suppressFooter = true,
//   loading,
//   onSubmit,
//   submitText = "Save Changes",
//   submitButtonSpacing = 4,
//   disabledWhenNoChanges = true,
//   sx,
// }) => {
//   const [formKey, setFormKey] = useState(0); // Key to force form re-initialization
//   const { changes, setChanges, hasChanges, getPayload, resetChanges } =
//     useFormChanges();

//   const handleSubmitProfileChanges = async (values, form) => {
//     const changedValues = getPayload();
//     // console.log("values", { changedValues, values, form });
//     // console.log("Profile updated successfully", test);
//     // dispatch(profileSet(test)); // Use the current form values, not EX_USER_DATA_UPDATED
//     // return;
//     if (isFunction(onSubmit)) {
//       onSubmit(changedValues, { changedValues, form, values, changes });
//       return;
//     }
//     // updateBorrowerProfile({
//     //   data: changedValues,
//     //   onSuccessFn: (d) => {
//     //     // console.log("Profile updated successfully", d);
//     //     dispatch(profileSet(d)); // Use the current form values, not EX_USER_DATA_UPDATED
//     //     // dispatch(profileSet(EX_USER_DATA_UPDATED)); // Use the current form values, not EX_USER_DATA_UPDATED
//     //     setFormKey((prev) => prev + 1);
//     //     resetChanges();
//     //   },
//     // });
//   };

//   // useEffect(() => {
//   //   console.log("profile", profile);
//   //   if (isNil(profile)) {
//   //     // Simulate async data loading
//   //     // setProfile(EX_USER_DATA);
//   //     console.log("11111", profile);
//   //     setTimeout(() => {
//   //       dispatch(profileSet(profile));
//   //       setInitialValues(profile);
//   //       setFormKey((prev) => prev + 1); // Force form re-initialization
//   //     }, 100);
//   //   } else {
//   //     console.log("22222", profile);
//   //     setInitialValues(profile);
//   //     setFormKey((prev) => prev + 1);
//   //   }
//   // }, [profile]);

//   return (
//     <RffForm
//       key={formKey} // Force re-initialization when profile loads
//       suppressFooter={suppressFooter}
//       // suppressFooter={hasChanges ? undefined : () => null}
//       initialValues={initialValues}
//       // formSpy
//       loading={loading}
//       sx={sx}
//       submitText={submitText}
//       onSubmit={handleSubmitProfileChanges}
//       // Show save button only when there are changes
//       // renderFooter={hasChanges ? undefined : () => null}
//     >
//       <FormChangeTracker
//         onChangesUpdate={setChanges}
//         initialValues={initialValues} // Pass initial values to tracker
//       />

//       {children}
//       {hasChanges ? hasChangesContent : null}
//       {suppressFooter ? (
//         <RffSubmitButton
//           size="large"
//           sx={{ flexGrow: 1, mt: submitButtonSpacing }}
//           loading={loading}
//           disabled={!hasChanges && disabledWhenNoChanges}
//           onClick={handleSubmitProfileChanges}
//         >
//           Save Changes
//         </RffSubmitButton>
//       ) : null}
//     </RffForm>
//   );
// };

// const FormChangeTracker = ({ onChangesUpdate, initialValues }) => {
//   const form = useForm();
//   const { values, pristine, dirty } = useFormState();
//   const [changedValues, setChangedValues] = useState({});
//   const initialValuesRef = useRef(null);
//   const [isInitialized, setIsInitialized] = useState(false);

//   // Update initial values reference when initialValues prop changes
//   useEffect(() => {
//     if (initialValues) {
//       // Always update the reference when initialValues change
//       initialValuesRef.current = JSON.parse(JSON.stringify(initialValues));

//       if (!isInitialized) {
//         setIsInitialized(true);
//       }

//       // Reset changes when initial values change (e.g., after save)
//       setChangedValues({});
//       if (onChangesUpdate) {
//         onChangesUpdate({});
//       }
//     }
//   }, [initialValues, onChangesUpdate]); // Remove isInitialized from dependencies

//   // Track changes only after initialization
//   useEffect(() => {
//     if (!isInitialized || !initialValuesRef.current || !values) return;

//     const changes = {};
//     const compareValues = (current, initial, path = "") => {
//       // Handle cases where current has keys that initial doesn't
//       const allKeys = new Set([
//         ...Object.keys(current || {}),
//         ...Object.keys(initial || {}),
//       ]);

//       allKeys.forEach((key) => {
//         const currentPath = path ? `${path}.${key}` : key;
//         const currentValue = current?.[key];
//         const initialValue = initial?.[key];

//         if (currentValue === undefined && initialValue === undefined) {
//           return;
//         }

//         if (
//           typeof currentValue === "object" &&
//           currentValue !== null &&
//           !Array.isArray(currentValue)
//         ) {
//           compareValues(currentValue, initialValue || {}, currentPath);
//         } else if (Array.isArray(currentValue)) {
//           if (!isEqual(currentValue, initialValue)) {
//             changes[currentPath] = currentValue;
//           }
//         } else if (currentValue !== initialValue) {
//           changes[currentPath] = currentValue;
//         }
//       });
//     };

//     compareValues(values, initialValuesRef.current);
//     setChangedValues(changes);

//     if (onChangesUpdate) {
//       onChangesUpdate(changes);
//     }
//   }, [values, isInitialized, onChangesUpdate]);

//   // Reset tracking when form is reset
//   useEffect(() => {
//     const unsubscribe = form.subscribe(
//       ({ pristine }) => {
//         if (pristine && isInitialized) {
//           setChangedValues({});
//           if (onChangesUpdate) {
//             onChangesUpdate({});
//           }
//         }
//       },
//       { pristine: true }
//     );

//     return unsubscribe;
//   }, [form, isInitialized, onChangesUpdate]);

//   return null; // This component doesn't render anything
// };

// // Hook to use form changes
// const useFormChanges = () => {
//   const [changes, setChanges] = useState({});
//   const hasChanges = Object.keys(changes).length > 0;

//   return {
//     changes,
//     setChanges,
//     hasChanges,
//     getPayload: () => {
//       // Convert dot notation back to nested object for payload
//       const payload = {};
//       Object.entries(changes).forEach(([path, value]) => {
//         const keys = path.split(".");
//         let current = payload;
//         keys.forEach((key, index) => {
//           if (index === keys.length - 1) {
//             current[key] = value;
//           } else {
//             current[key] = current[key] || {};
//             current = current[key];
//           }
//         });
//       });
//       return payload;
//     },
//     resetChanges: () => setChanges({}),
//   };
// };

// export default RffFormChanges;
